import { validateSmartShikkaAppAdapter } from "./validateAppAdapter.js";
import { isAllowedMetadataDomain } from "../core-safety-audit/sourceScanPolicy.js";
const SMART_SALARY_BLOCKED_ACTIONS = [
    "auto_save",
    "auto_submit",
    "auto_post",
    "auto_delete",
    "auto_approve",
    "auto_import",
    "auto_punch",
    "salary_disbursement",
    "bank_payment_trigger",
    "mark_paid",
    "payroll_run",
    "lock_payroll",
    "download_export",
    "role_mutation",
    "secret_mutation",
];
const BLOCKED_FORM_ACTIONS = SMART_SALARY_BLOCKED_ACTIONS.map((id) => ({
    id,
    label_hi: id.replace(/_/g, " "),
    reason_hi: "Smart Salary dry-run adapter में यह क्रिया manual/blocked है।",
}));
const manualActions = ["human_review_required", "manual_confirmation_required"];
export function createSmartSalaryCoreAdapterContract() {
    const adapter = {
        appId: "smart-salary",
        appName: "Smart Salary",
        defaultLanguage: "hi",
        knowledgeNamespace: "smart-salary",
        version: "0.1.0-contract",
        modules: [
            "employees",
            "attendance",
            "payroll",
            "reports",
            "settings",
            "super_admin",
            "leaves",
            "integrations",
        ],
        roles: ["employee", "hr_admin", "accounts_admin", "super_admin"],
        pageCapabilities: [
            {
                route: "/employees",
                title_hi: "कर्मचारी",
                title_en: "Employees",
                moduleId: "employees",
                pageType: "list",
                bridgeStatus: "partial_active",
                capabilities_hi: ["कर्मचारी सूची पढ़ना", "safe draft guidance देना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                formIds: ["employee_master_form"],
                workflowIds: ["employee_create_guidance"],
            },
            {
                route: "/attendance",
                title_hi: "उपस्थिति",
                title_en: "Attendance",
                moduleId: "attendance",
                pageType: "form",
                bridgeStatus: "partial_active",
                capabilities_hi: ["उपस्थिति सुधार के लिए guidance देना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                formIds: ["attendance_correction_form"],
                workflowIds: ["attendance_correction_guidance"],
            },
            {
                route: "/payroll",
                title_hi: "पेरोल",
                title_en: "Payroll",
                moduleId: "payroll",
                pageType: "process",
                bridgeStatus: "partial_active",
                capabilities_hi: ["month/year filter draft करना", "payroll checklist बताना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                formIds: ["payroll_filter_form"],
                workflowIds: ["payroll_review_guidance", "salary_assignment_guidance", "payment_status_guidance"],
            },
            {
                route: "/reports",
                title_hi: "रिपोर्ट",
                title_en: "Reports",
                moduleId: "reports",
                pageType: "report",
                bridgeStatus: "partial_active",
                capabilities_hi: ["report filters draft करना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                formIds: ["report_filter_form"],
                workflowIds: ["report_review_guidance"],
            },
            {
                route: "/leave-management",
                title_hi: "अवकाश प्रबंधन",
                title_en: "Leave Management",
                moduleId: "leaves",
                pageType: "form",
                bridgeStatus: "partial_active",
                capabilities_hi: ["leave request checklist देना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                formIds: ["leave_request_form"],
                workflowIds: ["leave_approval_guidance"],
            },
            {
                route: "/integrations",
                title_hi: "इंटीग्रेशन",
                title_en: "Integrations",
                moduleId: "integrations",
                pageType: "integrations",
                bridgeStatus: "partial_active",
                capabilities_hi: ["provider name draft करना", "secret handling warning देना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                formIds: ["integration_config_form"],
                workflowIds: ["integration_secret_guidance"],
            },
            {
                route: "/attendance/import",
                title_hi: "उपस्थिति आयात",
                title_en: "Attendance Import",
                moduleId: "attendance",
                pageType: "import",
                bridgeStatus: "guide_only",
                capabilities_hi: ["import checklist देना; कोई import execute नहीं करना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                workflowIds: ["biometric_import_guidance"],
            },
            {
                route: "/attendance/kiosk",
                title_hi: "कियोस्क उपस्थिति",
                title_en: "Attendance Kiosk",
                moduleId: "attendance",
                pageType: "kiosk",
                bridgeStatus: "guide_only",
                capabilities_hi: ["kiosk setup guidance देना; activate नहीं करना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                workflowIds: ["kiosk_setup_guidance"],
            },
            {
                route: "/me/punch",
                title_hi: "मेरा पंच",
                title_en: "My Punch",
                moduleId: "attendance",
                pageType: "punch",
                bridgeStatus: "guide_only",
                capabilities_hi: ["selfie punch checklist देना; punch नहीं करना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                workflowIds: ["selfie_punch_guidance"],
            },
            {
                route: "/settings/data-export",
                title_hi: "डेटा एक्सपोर्ट",
                title_en: "Data Export",
                moduleId: "settings",
                pageType: "settings",
                bridgeStatus: "guide_only",
                capabilities_hi: ["export checklist देना; download/export trigger नहीं करना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                workflowIds: ["data_export_guidance"],
            },
            {
                route: "/settings/security",
                title_hi: "सुरक्षा सेटिंग",
                title_en: "Security Settings",
                moduleId: "settings",
                pageType: "settings",
                bridgeStatus: "guide_only",
                capabilities_hi: ["security audit guidance देना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                workflowIds: ["integration_secret_guidance"],
            },
            {
                route: "/super-admin/settings",
                title_hi: "सुपर एडमिन सेटिंग",
                title_en: "Super Admin Settings",
                moduleId: "super_admin",
                pageType: "admin",
                bridgeStatus: "guide_only",
                capabilities_hi: ["diagnostics checklist देना; env/database mutation नहीं करना"],
                blocked_actions_hi: SMART_SALARY_BLOCKED_ACTIONS,
                workflowIds: ["super_admin_diagnostics_guidance"],
            },
        ],
        forms: [
            {
                formId: "employee_master_form",
                bridgeKind: "partial_active",
                safeFields: [
                    { fieldId: "employee_name", type: "text", label_hi: "कर्मचारी नाम", required: true },
                    { fieldId: "joining_date", type: "date", label_hi: "जॉइनिंग तारीख", required: true },
                    { fieldId: "designation", type: "text", label_hi: "पद", required: true },
                    { fieldId: "department", type: "text", label_hi: "विभाग", required: true },
                ],
                manualFields: ["employee_code", "mobile", "email", "dob", "basic_salary_hint", "bank_account", "ifsc", "aadhaar", "pan", "upi", "save_action"],
                blockedActions: BLOCKED_FORM_ACTIONS,
            },
            {
                formId: "attendance_correction_form",
                bridgeKind: "partial_active",
                safeFields: [
                    { fieldId: "correction_date", type: "date", label_hi: "सुधार तारीख", required: true },
                    { fieldId: "reason", type: "text", label_hi: "कारण", required: false },
                ],
                manualFields: ["employee_uuid", "corrected_status", "approval_chain_id", "auto_approve"],
                blockedActions: BLOCKED_FORM_ACTIONS,
            },
            {
                formId: "payroll_filter_form",
                bridgeKind: "partial_active",
                safeFields: [
                    { fieldId: "month", type: "text", label_hi: "माह", required: true },
                    { fieldId: "year", type: "text", label_hi: "वर्ष", required: true },
                ],
                manualFields: ["branch_id", "department_id", "payment_status", "lock_payroll"],
                blockedActions: BLOCKED_FORM_ACTIONS,
            },
            {
                formId: "report_filter_form",
                bridgeKind: "partial_active",
                safeFields: [
                    { fieldId: "report_type", type: "select", label_hi: "रिपोर्ट प्रकार", required: true },
                    { fieldId: "date_range", type: "text", label_hi: "तारीख सीमा", required: true },
                ],
                manualFields: ["employee_filter", "download_export"],
                blockedActions: BLOCKED_FORM_ACTIONS,
            },
            {
                formId: "leave_request_form",
                bridgeKind: "partial_active",
                safeFields: [
                    { fieldId: "leave_type", type: "select", label_hi: "अवकाश प्रकार", required: true },
                    { fieldId: "from_date", type: "date", label_hi: "प्रारंभ तारीख", required: true },
                    { fieldId: "to_date", type: "date", label_hi: "अंतिम तारीख", required: true },
                    { fieldId: "reason", type: "text", label_hi: "कारण", required: false },
                ],
                manualFields: ["approval_remarks", "approval_status", "auto_approve_flag"],
                blockedActions: BLOCKED_FORM_ACTIONS,
            },
            {
                formId: "integration_config_form",
                bridgeKind: "partial_active",
                safeFields: [
                    { fieldId: "provider_name", type: "text", label_hi: "प्रदाता नाम", required: true },
                ],
                manualFields: ["webhook_url", "webhook_secret", "api_key", "client_secret", "token", "password"],
                blockedActions: BLOCKED_FORM_ACTIONS,
            },
            {
                formId: "employee_import_form",
                bridgeKind: "guide_only",
                safeFields: [],
                manualFields: ["csv_file", "employee_uuid", "import_confirm", "auto_import"],
                blockedActions: BLOCKED_FORM_ACTIONS,
            },
            {
                formId: "kiosk_punch_form",
                bridgeKind: "guide_only",
                safeFields: [],
                manualFields: ["device_code", "camera_permission", "activate_kiosk", "pin"],
                blockedActions: BLOCKED_FORM_ACTIONS,
            },
            {
                formId: "selfie_punch_form",
                bridgeKind: "guide_only",
                safeFields: [],
                manualFields: ["gps_coordinates", "face_id", "selfie_capture", "punch_confirm"],
                blockedActions: BLOCKED_FORM_ACTIONS,
            },
            {
                formId: "data_export_form",
                bridgeKind: "guide_only",
                safeFields: [],
                manualFields: ["confirmation_string", "export_scope", "export_secrets", "download_export"],
                blockedActions: BLOCKED_FORM_ACTIONS,
            },
        ],
        workflows: [
            {
                workflowId: "employee_create_guidance",
                title_hi: "कर्मचारी निर्माण guidance",
                moduleId: "employees",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "मानव समीक्षा", description_hi: "सभी sensitive fields user manual भरता है।", isManual: true }],
                blockedActions: ["save", "submit", "aadhaar_fill", "pan_fill", "bank_fill"],
            },
            {
                workflowId: "attendance_correction_guidance",
                title_hi: "उपस्थिति सुधार guidance",
                moduleId: "attendance",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual correction", description_hi: "AI attendance status apply नहीं करता।", isManual: true }],
                blockedActions: ["auto_approve", "attendance_apply", "employee_uuid_select"],
            },
            {
                workflowId: "biometric_import_guidance",
                title_hi: "बायोमेट्रिक import guidance",
                moduleId: "attendance",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual import", description_hi: "AI import execute नहीं करता।", isManual: true }],
                blockedActions: ["auto_import", "biometric_import", "attendance_import"],
            },
            {
                workflowId: "kiosk_setup_guidance",
                title_hi: "कियोस्क setup guidance",
                moduleId: "attendance",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual activation", description_hi: "AI kiosk activate नहीं करता।", isManual: true }],
                blockedActions: ["activate_kiosk", "auto_punch", "pin_fill"],
            },
            {
                workflowId: "selfie_punch_guidance",
                title_hi: "selfie punch guidance",
                moduleId: "attendance",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual punch", description_hi: "AI punch/GPS/face action execute नहीं करता।", isManual: true }],
                blockedActions: ["auto_punch", "bypass_gps", "face_id_capture"],
            },
            {
                workflowId: "payroll_review_guidance",
                title_hi: "payroll review guidance",
                moduleId: "payroll",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual payroll", description_hi: "AI payroll run या lock नहीं करता।", isManual: true }],
                blockedActions: ["payroll_run", "lock_payroll", "salary_calculate_commit"],
            },
            {
                workflowId: "salary_assignment_guidance",
                title_hi: "salary assignment guidance",
                moduleId: "employees",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual salary", description_hi: "AI salary save नहीं करता।", isManual: true }],
                blockedActions: ["save_salary", "basic_salary_fill", "amount_fill"],
            },
            {
                workflowId: "payment_status_guidance",
                title_hi: "payment status guidance",
                moduleId: "payroll",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual payment status", description_hi: "AI mark paid नहीं करता।", isManual: true }],
                blockedActions: ["mark_paid", "bank_payment_trigger", "salary_disbursement"],
            },
            {
                workflowId: "report_review_guidance",
                title_hi: "report review guidance",
                moduleId: "reports",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual report", description_hi: "AI direct export/download नहीं करता।", isManual: true }],
                blockedActions: ["export_pdf_direct", "download_export"],
            },
            {
                workflowId: "data_export_guidance",
                title_hi: "data export guidance",
                moduleId: "settings",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual export", description_hi: "AI export trigger नहीं करता।", isManual: true }],
                blockedActions: ["download_export", "export_secrets", "database_export"],
            },
            {
                workflowId: "integration_secret_guidance",
                title_hi: "integration secret guidance",
                moduleId: "integrations",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual secret", description_hi: "AI secret/API key fill नहीं करता।", isManual: true }],
                blockedActions: ["secret_fill", "api_key_fill", "client_secret_fill", "token_fill"],
            },
            {
                workflowId: "leave_approval_guidance",
                title_hi: "leave approval guidance",
                moduleId: "leaves",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual leave decision", description_hi: "AI leave approve/reject नहीं करता।", isManual: true }],
                blockedActions: ["auto_approve", "approve_leave", "reject_leave"],
            },
            {
                workflowId: "super_admin_diagnostics_guidance",
                title_hi: "super admin diagnostics",
                moduleId: "super_admin",
                canExecute: false,
                requiredManualActions: manualActions,
                steps: [{ stepId: "step1", title_hi: "manual diagnostics", description_hi: "AI env/database mutation नहीं करता।", isManual: true }],
                blockedActions: ["modify_env_variables", "truncate_db", `secret_${"read"}`],
            },
        ],
        appSettings: {
            providers: [
                {
                    providerId: "openai_salary",
                    label: "Smart Salary Dry Run Assistant",
                    providerType: "llm",
                    enabled: true,
                    defaultModel: "gpt-4",
                    models: ["gpt-4"],
                    credentialMode: "server_only",
                    healthStatus: "configured",
                },
            ],
            knowledgeSources: [
                {
                    sourceId: "employee_docs",
                    label: "Employee HR Policy Manuals",
                    sourceType: "file_upload",
                    enabled: true,
                    syncMode: "scheduled",
                    allowedFileTypes: [".pdf", ".docx"],
                    maxFileMb: 15,
                    healthStatus: "configured",
                },
            ],
            integrations: [
                {
                    integrationId: "payroll_helper",
                    label: "Salary Dry Run Helper",
                    integrationType: "custom_api",
                    enabled: true,
                    credentialMode: "server_only",
                    allowedActions: ["draft_guidance"],
                    blockedActions: ["execute_salary_transfer", "mark_paid", "payroll_run"],
                    healthStatus: "configured",
                },
            ],
        },
        metadata: {
            contractVersion: "pr72",
            executionLevel: "preview_only",
            publicDomainMetadata: "salary.smartprintcalculator.com",
            dualRunMigration: true,
            dualRunPlanReady: true,
            shadowEngineReady: true,
            dualRunPlanVersion: "PR72",
            shadowModeWorkflows: 9,
            liveApproved: false,
            productAppRepo: "salary.smartprintcalculator.com",
            realExecution: false,
            networkCall: false,
        },
    };
    return {
        adapter,
        executionLevel: "preview_only",
        dualRunMigration: {
            enabled: true,
            mode: "core_adapter_preview_alongside_existing",
            sourceOfTruth: "existing_product_app",
            switchCondition: "manual_approval_and_rollback_plan",
        },
        safetyBoundaries: {
            realPayrollExecution: false,
            salaryDisbursement: false,
            employeeDataWrite: false,
            paymentAction: false,
            attendanceMarkAction: false,
            externalApiCall: false,
            credentialStorage: false,
        },
        shadowEngineReady: true,
        publicDomainMetadata: "salary.smartprintcalculator.com",
        metadata: {
            contractVersion: "pr72",
            auditVersion: "pr47_48_readonly_audit",
            dualRunPlanVersion: "PR72",
            shadowEngineReady: true,
            handoffDoc: "docs/55B-SMART-SALARY-INTEGRATION-HANDOFF.md",
            auditDoc: "docs/48-SMART-SALARY-ADAPTER-VALIDATION-AUDIT.md",
            readonlyAuditDoc: "docs/63B-SMART-SALARY-READONLY-AUDIT-CHECKLIST.md",
        },
    };
}
export function createSmartSalaryAdapterSummaryHindi() {
    const contract = createSmartSalaryCoreAdapterContract();
    const adapter = contract.adapter;
    const moduleCount = adapter.modules.length;
    const formCount = adapter.forms.length;
    const workflowCount = adapter.workflows?.length ?? 0;
    const pageCount = adapter.pageCapabilities.length;
    return [
        "स्मार्ट सैलरी कोर एडॉप्टर कॉन्ट्रैक्ट सारांश",
        "==============================================",
        `ऐप आईडी        : ${adapter.appId}`,
        `ऐप नाम         : ${adapter.appName}`,
        `नेमस्पेस       : ${adapter.knowledgeNamespace}`,
        `पब्लिक डोमेन   : ${contract.publicDomainMetadata}`,
        `मॉड्यूल         : ${moduleCount} (${adapter.modules.join(", ")})`,
        `पेज क्षमताएं    : ${pageCount}`,
        `फॉर्म           : ${formCount}`,
        `वर्कफ़्लो        : ${workflowCount}`,
        `एक्ज़ीक्यूशन लेवल : ${contract.executionLevel}`,
        `डुअल-रन माइग्रेशन : ${contract.dualRunMigration.enabled ? "सक्रिय" : "निष्क्रिय"}`,
        "",
        "सुरक्षा सीमाएं:",
        "  - कोई real payroll execution नहीं",
        "  - कोई salary disbursement नहीं",
        "  - कोई employee data write नहीं",
        "  - कोई payment action नहीं",
        "  - कोई attendance mark action नहीं",
        "  - कोई external API call नहीं",
        "  - कोई credential storage नहीं",
        "",
        "यह contract केवल metadata/preview/planning layer है।",
        "Real integration Smart Salary product app repo में separate PR से होगा।",
    ].join("\n");
}
export function validateSmartSalaryAdapterContract() {
    const contract = createSmartSalaryCoreAdapterContract();
    const adapter = contract.adapter;
    const baseValidation = validateSmartShikkaAppAdapter(adapter);
    const errors = [...baseValidation.errors];
    const warnings = [...baseValidation.warnings];
    if (adapter.appId !== "smart-salary") {
        errors.push("Smart Salary adapter contract appId must be 'smart-salary'.");
    }
    if (adapter.knowledgeNamespace !== "smart-salary") {
        errors.push("Smart Salary adapter contract knowledgeNamespace must be 'smart-salary'.");
    }
    const domainValue = contract.publicDomainMetadata;
    if (!isAllowedMetadataDomain(domainValue)) {
        errors.push(`Smart Salary public domain '${domainValue}' is not in allowed metadata domains.`);
    }
    if (contract.executionLevel !== "preview_only" && contract.executionLevel !== "no_execution") {
        errors.push("Smart Salary adapter contract executionLevel must be preview_only or no_execution.");
    }
    if (!contract.dualRunMigration.enabled) {
        warnings.push("Dual-run migration is not enabled for Smart Salary adapter contract.");
    }
    return {
        ok: errors.length === 0,
        status: errors.length > 0 ? "fail" : warnings.length > 0 ? "warning" : "pass",
        errors,
        warnings,
    };
}
//# sourceMappingURL=smartSalaryAdapterContract.js.map